/* eslint-disable max-classes-per-file */
import { Action } from '@ngrx/store';

import { InteractionType, Feature } from '../../models';

export enum MapContextActionTypes {
  SetInteractionType = '[MapContext] Set Interaction Type',
  SetPreviousInteractionType = '[MapContext] Set previous Interaction Type',
  SetCropFieldsEnabled = '[MapContext] Set crop fields Enabled',
  SetBlightLayerEnabled = '[MapContext] Set Blight layer Enabled',
  SetRvoEnabled = '[MapContext] Set Rvo Enabled',
  SetSoilAnalysesEnabled = '[MapContext] Set soil analyses Enabled',
  SetSelectLastYearsFieldEnabled = '[MapContext] Set select last years field Enabled',
  SetCopyShapefileEnabled = '[MapContext] Set copy shapefile layer Enabled',
  SaveShapefileFeatures = '[MapContext] Save shapefile featureCollection',
  ToggleCropFields = '[MapContext] Toggle crop fields',
  InteractionReady = '[MapContext] Interaction Ready',
}

export class SetInteractionType implements Action {
  readonly type = MapContextActionTypes.SetInteractionType;
  constructor(public readonly interactionType: InteractionType) {}
}

export class SetPreviousInteractionType implements Action {
  readonly type = MapContextActionTypes.SetPreviousInteractionType;
  constructor(public readonly interactionType: InteractionType) {}
}

export class SetCropFieldsEnabled implements Action {
  readonly type = MapContextActionTypes.SetCropFieldsEnabled;
  constructor(public readonly enabled: boolean) {}
}

export class SetBlightLayerEnabled implements Action {
  readonly type = MapContextActionTypes.SetBlightLayerEnabled;
  constructor(public readonly enabled: boolean) {}
}

export class SetSoilAnalysesEnabled implements Action {
  readonly type = MapContextActionTypes.SetSoilAnalysesEnabled;
  constructor(public readonly enabled: boolean) {}
}

export class SetRvoEnabled implements Action {
  readonly type = MapContextActionTypes.SetRvoEnabled;
  constructor(public readonly enabled: boolean) {}
}

export class SetSelectLastYearsFieldEnabled implements Action {
  readonly type = MapContextActionTypes.SetSelectLastYearsFieldEnabled;
  constructor(public readonly enabled: boolean) {}
}

export class SetCopyShapefileEnabled implements Action {
  readonly type = MapContextActionTypes.SetCopyShapefileEnabled;
  constructor(public readonly enabled: boolean) {}
}

export class SaveShapefileFeatures implements Action {
  readonly type = MapContextActionTypes.SaveShapefileFeatures;
  constructor(public readonly features: Feature[]) {}
}

export class ToggleCropFields implements Action {
  readonly type = MapContextActionTypes.ToggleCropFields;
}

export class InteractionReady implements Action {
  readonly type = MapContextActionTypes.InteractionReady;
  constructor() {}
}

// export the combined type of all actions
export type MapContextActions =
  | SetInteractionType
  | SetPreviousInteractionType
  | SetRvoEnabled
  | SetSelectLastYearsFieldEnabled
  | SetCropFieldsEnabled
  | SetBlightLayerEnabled
  | SetSoilAnalysesEnabled
  | SetCopyShapefileEnabled
  | SaveShapefileFeatures
  | ToggleCropFields
  | InteractionReady;
